import getCookieByName from '../../storage/getCookieByName';
import getFieldValue from '../elements/getFieldValue';

/**
 * Converts lead attribution fields into a query string to send as a single param
 *
 * @param {element} form
 * @returns {string}
 */
function attributionField(form) {
  const fieldNames = ['vtmedium', 'vtsource', 'vtcampaign', 'vtplacement', 'leadform', 'abtest'];

  const attributionFields = fieldNames
    .map(fieldName => `${fieldName}=${getFieldValue(form, fieldName) || ''}`)
    .filter(value => !value.match(/=$/));

  // Impact radius refers potential leads, which marketing tracks
  const irclickid = getCookieByName('irclickid');
  if (irclickid) { attributionFields.push(`;;irclickid=${irclickid}`); }

  return attributionFields.join('&');
}

/**
 * Creates the leads Page field from the conversion page url and params we want
 * to pass to vt-contact (including query string on conversion page, as well as
 * attribution fields from hidden input fields).
 *
 * @param {element} form
 * @returns {string}
 */
export default function getPageValue(form, conversionPage) {
  if (!conversionPage) conversionPage = window.location.href.split('#')[0];

  const attrField = attributionField(form);
  if(!attrField) return conversionPage.replace(/\?$/); // vtwa admin crashes when URL ends in '?'

  const result = [conversionPage, attrField];
  return conversionPage.includes('?') ? result.join('&') : result.join('?');
}
